import { useEffect, useState } from 'react'

import { StyledImage } from './styles'
import Toast from './Toast'

import { Button } from 'components/v2/Button'
import { Row } from 'components/v2/Grid'
import { Text } from 'components/v2/Text'

import { checkIsMobile } from 'utils/helpers'

const FirstFold = ({ handleModal }) => {
	const [showToast, setShowToast] = useState(true)
	const [isMobile, setIsMobile] = useState(undefined)

	const closeToast = () => {
		localStorage.setItem('showFirstFoldToast', false)
		setShowToast(false)
	}

	useEffect(() => {
		const showFirstFoldToast = localStorage.getItem('showFirstFoldToast')

		if (showFirstFoldToast === null) {
			localStorage.setItem('showFirstFoldToast', true)
		}

		if (showFirstFoldToast === 'false') {
			setShowToast(false)
		}
		setIsMobile(checkIsMobile(993))
	}, [])

	return (
		<Row className='relative h-[calc(100vh-60px)] justify-center overflow-hidden bg-orange-600 p-4 text-left md:h-[calc(100vh-86px)]'>
			<Row className='z-[2] w-full max-w-[1200px] items-center px-5'>
				<div className='flex w-full min-w-0 max-w-[709px] flex-col justify-start md:flex-[0_0_50%]'>
					<Text className='mb-1 text-white'>TERAPIA ONLINE</Text>
					<Text className='mb-6 text-[40px] font-semibold text-white'>
						Seu psicólogo a qualquer hora, em qualquer lugar.
					</Text>
					<Button
						variant='primary-refit'
						className='h-14 w-fit bg-white text-sm font-semibold leading-[19px] text-orange-600'
						onClick={() => handleModal()}
					>
						Escolher meu psicólogo
					</Button>
				</div>
			</Row>

			<StyledImage
				src='/static/images/home-hero.png'
				alt='Homem olhando feliz para tela do celular'
			/>

			{!isMobile && showToast && (
				<Toast handleModal={handleModal} closeToast={closeToast} />
			)}
		</Row>
	)
}

export default FirstFold
